import React, { useEffect, useId, useState } from "react";
import styled from "styled-components";
import { Box, SpanStyled } from "../../../../components/styled/Elements";
import { Cancel, PlusGrey } from "../../../../components/styled/AllImages";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import { getVideoSrc, getVideoThumbnail } from "../../../../utils";

const max = 10;

const MultipleVideoUpload = ({
  onChange,
  onRemove,
  selectedVideos,
  setDeletedVideos,
  resetTrigger,
  max = 10,
  isLoading = false,
  disabled = false,
  minDuration = 1, // in seconds
  maxDuration = 60, // in seconds
}) => {
  const [videos, setVideos] = useState([]);
  const [isPreviewLoading, setIsPreviewLoading] = useState(false);
  const uniqueId = useId();
  const { t } = useTranslation();

  const handleFileChange = async (event) => {
    const files = Array.from(event.target.files);

    // const totalSelected = videos.length + files.length;

    // if (totalSelected > max) {
    //   const remainingSlots = max - files.length;

    //   if (remainingSlots < 0) {
    //     // toast.error(t("max_limit_reached", { max }));
    //     toast.error(
    //       t("partial_upload_limit", {
    //         accepted: max,
    //         selected: files.length,
    //         skipped: files.length - max,
    //         max,
    //       })
    //     );
    //   }
    //   if (max - totalSelected > 0)
    //     errorMessages.push(
    //       t("limit_remaining", { count: max - totalSelected })
    //     );
    // }

    // const remainingSlots = max - videos.length;

    if (files.length === 0) return;

    const currentVideoCount = videos.length;
    const selectedFileCount = files.length;
    const remainingSlots = max - currentVideoCount;

    // Calculate how many files can be accepted
    const acceptedCount = Math.min(selectedFileCount, remainingSlots);
    const skippedCount = selectedFileCount - acceptedCount;

    // Show appropriate toast messages
    if (remainingSlots < 0) {
      // No slots available
      toast.error(t("max_limit_reached", { max }));
    } else if (skippedCount > 0) {
      // Some files accepted, some skipped
      toast.warning(
        t("partial_upload_limit", {
          accepted: acceptedCount,
          selected: selectedFileCount,
          skipped: skippedCount,
          max,
        })
      );
    }

    const selected = files.slice(0, remainingSlots);
    const validVideos = [];

    for (let file of selected) {
      const url = URL.createObjectURL(file);
      const duration = await getVideoDuration(url);
      if (duration >= minDuration && duration <= maxDuration) {
        const thumbnail = await getVideoThumbnail(file);
        validVideos.push({
          id: url,
          file,
          thumbnail,
        });
      } else {
        toast.warning(
          t("invalid_duration", {
            fileName: file.name,
            duration: Math.round(duration),
            min: minDuration,
            max: maxDuration,
          })
        );
        URL.revokeObjectURL(url);
      }
    }

    if (validVideos.length > 0) {
      const newVideos = [...videos, ...validVideos];
      setVideos(newVideos);
      onChange(newVideos.map((video) => video.file));
    }

    // const files = event.target.files;
    // if (files.length > 0) {
    //   const newVideos = [...videos];
    //   for (let i = 0; i < files.length; i++) {
    //     if (newVideos.length < max) {
    //       newVideos.push({
    //         id: URL.createObjectURL(files[i]),
    //         file: files[i],
    //       });
    //     }
    //   }
    //   setVideos(newVideos);
    //   onChange(newVideos.map((video) => video.file));
    // }
  };

  const getVideoDuration = (src) => {
    return new Promise((resolve) => {
      const video = document.createElement("video");
      video.preload = "metadata";
      video.onloadedmetadata = function () {
        resolve(video.duration);
        URL.revokeObjectURL(video.src);
      };
      video.src = src;
    });
  };

  const removeVideo = (id, videoId, index) => {
    const filtered = videos.filter((vid) => vid.id !== id);
    setVideos(filtered);
    if (onRemove) {
      onRemove(
        selectedVideos?.filter((_, i) => i != index)?.map((v) => v.video)
      );
    }
    if (videoId) {
      setDeletedVideos((prev) => [...prev, videoId]);
    }
  };

  useEffect(() => {
    if (
      selectedVideos &&
      Array.isArray(selectedVideos) &&
      selectedVideos.length > 0
    ) {
      setVideos(
        selectedVideos.map((vid) => ({
          videoId: vid?.id,
          id: vid?.video,
          file: vid?.video,
        }))
      );
    }
  }, []);

  useEffect(() => {
    if (resetTrigger !== 0) setVideos([]);
  }, [resetTrigger]);

  return (
    <VideoUploadContainer>
      {disabled && (
        <div className="overlayLoader">
          {isLoading && (
            <Box>
              <Box className="d-flex justify-content-center">
                <div
                  className="spinner-border text-primary mx-auto"
                  role="status"
                />
              </Box>
              <Box className="mt-2">
                <SpanStyled color="var(--text)">
                  {t("please_wait_vid_upload")}
                </SpanStyled>
              </Box>
            </Box>
          )}
        </div>
      )}
      {/* {isPreviewLoading && (
        <div className="overlayLoader">
          <Box className="d-flex justify-content-center">
            <div
              className="spinner-border text-primary mx-auto"
              role="status"
            />
          </Box>
        </div>
      )} */}
      <Box className="videoPreviewGrid">
        {videos.map((video, i) => {
          const src = getVideoSrc(video?.file)
          return (
          <Box key={video.id} className="videoThumbnail">
            <video
              src={src}
              className="previewVideo"
              muted
              playsInline
              preload="metadata"
              onLoadedMetadata={(e) => (e.currentTarget.currentTime = 0.1)}
            />

            {/* <img src={video.thumbnail} className="previewVideo" /> */}
            <button
              className="deleteButton"
              onClick={() => {
                if (!disabled) removeVideo(video.id, video?.videoId, i);
              }}
            >
              <Cancel />
            </button>
          </Box>
        )})}

        {videos?.length < max && (
          <Box
            className="addVideoButton"
            onClick={() => {
              if (!disabled)
                document.getElementById(`videoInput-${uniqueId}`).click();
            }}
          >
            <PlusGrey />
          </Box>
        )}
      </Box>

      <input
        id={`videoInput-${uniqueId}`}
        type="file"
        accept="video/mp4, video/webm, video/ogg, video/mov"
        multiple
        style={{ display: "none" }}
        onChange={(event) => {
          if (!disabled) handleFileChange(event);
        }}
      />
    </VideoUploadContainer>
  );
};

export default MultipleVideoUpload;
const VideoUploadContainer = styled.div`
  position: relative;
  .overlayLoader {
    position: absolute;
    inset: 0;
    background-color: rgba(255, 255, 255, 0.6);
    backdrop-filter: blur(1px);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 10;
    border-radius: 10px;
  }
  .videoPreviewGrid {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
  }

  .videoThumbnail {
    position: relative;
    width: 113px;
    height: 100px;
    border-radius: 10px;
    overflow: hidden;
    background-color: var(--bg);
    border: 1px solid var(--border);
  }

  .previewVideo {
    width: 100%;
    height: 100%;
    object-fit: cover;
    pointer-events: none;
  }

  .deleteButton {
    position: absolute;
    top: 5px;
    right: 5px;
    background: rgba(255, 0, 0, 0.7);
    color: white;
    border: none;
    border-radius: 50%;
    width: 20px;
    height: 20px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    svg {
      width: 10px;
      height: 10px;
      [stroke] {
        stroke: var(--white);
      }
      [fill] {
        fill: var(--white);
      }
    }
  }

  .addVideoButton {
    width: 113px;
    height: 100px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 8px;
    cursor: pointer;
    background-color: var(--bg);
    border: 1px solid var(--border);
  }
`;
